// Shared quick-range presets for the report filter bars, so VSM History and Vehicle Sync
// History offer the same choices and mean the same thing by them. 'custom' reveals the
// date pickers; the numbers are days back from today.
export const RANGES = [
  { value: 1, label: '1d', text: '1', title: 'Today' },
  { value: 7, label: '7d', text: '7', title: 'Last 7 days' },
  { value: 30, label: '30d', text: '30', title: 'Last 30 days' },
  { value: 'custom', label: 'Custom', text: 'Custom', title: 'Set a specific From / To window' },
]
